import { DebugEvent } from 'core/DebugEvent';
import { UIThemeColourType } from 'app/data/Enums';

interface SidebarChangeEventInterface {
	theme: UIThemeColourType;
	index: number;
}

export class SidebarChangeEvent extends DebugEvent implements SidebarChangeEventInterface {
	public static eventName: string = 'SIDEBAR_CHANGE_EVENT';
	public theme: UIThemeColourType;
	public index: number;

	constructor(parameters: SidebarChangeEventInterface) {
		super(parameters);
	}
}
